import { Button, ButtonGroup, Card, Image, Overlay } from 'react-bootstrap';

import { Handle } from 'react-flow-renderer';
import React from 'react';
import branchingIcon from './workflow-ab-branching.png';
import deleteIcon from './workflow-node-delete.png';
import editIcon from './workflow-edit.png';
import { useState, useRef } from 'react';
import { WorkflowResourcePopOver } from '../../popover/WorkflowResourcePopOver';
import { WORKFLOW_STEP_TYPES } from '../../../../../global/constants';

export const WorkflowNode = ({ id, data }) => {
  const popOverTarget = useRef(null);
  const [isHoverOver, setIsHoverOver] = useState(false);

  const onMouseEnterHandler = () => {
    switch (data.node.type) {
      case WORKFLOW_STEP_TYPES.TranslationMemory:
      case WORKFLOW_STEP_TYPES.MachineTranslation:
      case WORKFLOW_STEP_TYPES.TerminologyBase:
      case WORKFLOW_STEP_TYPES.Luma:
        setIsHoverOver(true);
        break;
      case WORKFLOW_STEP_TYPES.SegmentAndFilter:
        setIsHoverOver(false);
        break;
      default:
        setIsHoverOver(false);
    }
  };

  const onMouseLeaveHandler = () => {
    setIsHoverOver(false);
  };

  const CardHeaderSection = () => {
    return (
      <Card.Header className="p-0 text-center">
        <ButtonGroup>
          {data.canEdit ? (
            <Button
              className="node-icon-size p-2px mx-4px"
              variant="outline-success"
              onClick={() => data.callbacks.editNode(id)}
            >
              <Image src={editIcon} width={20} height={20} />
            </Button>
          ) : null}
          {data.canDelete ? (
            <Button
              className="node-icon-size p-2px mx-4px"
              variant="outline-warning"
              onClick={() => data.callbacks.removeNode(id)}
            >
              <Image src={deleteIcon} fluid />
            </Button>
          ) : null}
          {data.canBranch ? (
            <Button
              className="node-icon-size p-2px mx-4px"
              variant="outline-danger"
              onClick={() => data.callbacks.addAbTest(id)}
            >
              <Image src={branchingIcon} fluid />
            </Button>
          ) : null}
        </ButtonGroup>
      </Card.Header>
    );
  };
  const hasButtons = data.canEdit || data.canDelete || data.canBranch;
  const cardClasses = hasButtons ? 'py-1 text-center' : 'buttonless-node align-middle';
  return (
    <div className="text-center node-size">
      <Handle type="target" position="left" />
      <Card className="h-100">
        {hasButtons ? <CardHeaderSection /> : null}
        <Card.Body
          ref={popOverTarget}
          onMouseEnter={onMouseEnterHandler}
          onMouseLeave={onMouseLeaveHandler}
          className={cardClasses}
        >
          <Card.Text>{data.label}</Card.Text>
        </Card.Body>
        <Overlay target={popOverTarget.current} show={isHoverOver} placement="bottom">
          {({ ...props }) => <WorkflowResourcePopOver node={data.node} {...props} />}
        </Overlay>
      </Card>
      <Handle type="source" position="right" />
    </div>
  );
};
